import { Component, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { AbstractWidgetComponent, AppClientConfiguration, AppServerAPI } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { AdditionalVisitor, InviteVisitor } from '../additional-visitor.model';
import { TerminalContextConstants } from '@sdbn/tmc-common';
import { Router } from '@angular/router';

@Component({
    selector: 'app-additional-visitor',
    templateUrl: './additional-visitor.component.html',
    styleUrls: ['./additional-visitor.component.scss'],
    standalone: false
})
export class AdditionalVisitorComponent extends AbstractWidgetComponent implements OnInit {

  masterdataForm = new FormGroup({});

  inviterId: number;
  currentAdditionalVisitor = new InviteVisitor();
  additionalVisitors = new Array<AdditionalVisitor>();

  clientURLRoot: string;

  constructor(
    private router: Router,
    public translationService: TranslationService,
    private appClientConfiguration: AppClientConfiguration
  ) {
    super();
  }

  ngOnInit(): void {
    this.masterdataForm.addControl('name', new FormControl(null, [Validators.required]));
    this.masterdataForm.addControl('firstname', new FormControl(null, [Validators.required]));
    this.masterdataForm.addControl('mail', new FormControl(null, [Validators.required]));
    this.masterdataForm.statusChanges.subscribe(s => {
      console.log('form status', this.masterdataForm.valid, this.masterdataForm);
    });



  }

  onContextChange(contextChange: ContextChange) {
    console.log('onContextChange', contextChange);
    if (contextChange.key === 'additionalVisitors') {
      this.additionalVisitors = contextChange.value;
    }
  }

  onSetElementAndContext() {
    console.log('onContextChange', this.dashboardContext.getContextValue('additionalVisitors'));
    this.inviterId = this.dashboardContext.getContextValue(TerminalContextConstants.registrationId);
    this.currentAdditionalVisitor = new InviteVisitor();
    this.currentAdditionalVisitor.inviterId = this.inviterId;
    this.additionalVisitors = this.dashboardContext.getContextValue('additionalVisitors');
    this.masterdataForm.valueChanges.subscribe(values => {
      this.currentAdditionalVisitor.firstname = values.firstname;
      this.currentAdditionalVisitor.name = values.name;
      this.currentAdditionalVisitor.mail = values.mail;
      this.currentAdditionalVisitor.phone = values.phone;
    });
  }

  inviteAdditionalVisitor() {
    this.dashboardContext.setContextValue('inviteVisitor', this.currentAdditionalVisitor);
    this.currentAdditionalVisitor = new InviteVisitor();
    this.currentAdditionalVisitor.inviterId = this.inviterId;
    this.masterdataForm.patchValue({
      name: '',
      firstname: '',
      mail: '',
      phone: ''
    });

  }

  public copyInvitationToClipboard(additionalVisitor: AdditionalVisitor) {
    const url = this.appClientConfiguration.clientURLRoot + '/dl/' + this.getDeeplinkIdentifierFromCurrentUrl + '?registrationCode=';
    const invitationLink = url + additionalVisitor.registrationCode;
    navigator.clipboard.writeText(invitationLink).then(() => {
      console.log('Invitation link copied to clipboard:', invitationLink);
    }).catch(err => {
      console.error('Failed to copy invitation link: ', err);
    });
  }

  private getDeeplinkIdentifierFromCurrentUrl(): string | null {
    const path = this.router.url.split('?')[0].split('#')[0];
    const parts = path.split('/').filter((p) => p);

    const dlIndex = parts.indexOf('dl');
    if (dlIndex === -1 || dlIndex === parts.length - 1) {
      return null;
    }

    return parts[dlIndex + 1];
  }
}
